import QRCode from "react-qr-code";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import line from "../assets/line.png";
import home from "../assets/home.png";
export default function Thankyou() {
  const navigate = useNavigate();
  const location = useLocation();
  // const { city } = location.state;
  const { s3_link } = location.state?.deepfakeData || "";

  console.log(s3_link);

  return (
    <div className="flex flex-col items-center h-screen backdrop-blur-lg">
      <div
        className="flex justify-center font-bold text-white py-14 text-center"
        // onClick={onClick}
      >
        <img
          src={logo}
          alt=""
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        />
      </div>
      <div className="flex items-center flex-row">
        {/* <div className="flex justify-end items-center">
          {s3_link && (
            <img
              src={s3_link}
              alt="Generated Image"
              // onClick={handleTryAgainClick}
              className="cursor-pointer w-4/5 object-contain"
            />
          )}
        </div> */}
        <div className="w-full flex flex-col items-center justify-center ">
          <div
            className="p-3 rounded-2xl shadow-lg"
            style={{
              background:
                "linear-gradient(115deg, #66ccff, #ffcc66, #ff9933, #33cc33)",
            }}
          >
            <QRCode
              size={356}
              value={s3_link}
              viewBox={`0 0 456 456`}
              className="p-10 bg-[#103264] rounded-2xl"
              bgColor="#103264"
              fgColor="#fff"
            />
          </div>
        </div>
      </div>
      <div
        className="text-center text-[#1E5898] w-4/6 text-[39px] font-semibold leading-[103%] mt-16"
        style={{ textShadow: "2px 2px 8px rgba(128, 128, 128, 0.8)" }}
      >
        SCAN THE QR CODE TO DOWNLOAD YOUR PHOTO
      </div>
      <img src={line} alt="" className="my-10" />
      <div
        className="text-center text-[#1E5898] w-4/6 text-[39px] font-semibold leading-[103%]"
        style={{ textShadow: "2px 2px 8px rgba(128, 128, 128, 0.8)" }}
      >
        Thank you for participating
      </div>
      <div className="flex justify-center items-center flex-col mt-12 gap-8">
        <img src={home} alt="" onClick={() => navigate("/")} />
      </div>
    </div>
  );
}
